/* eslint no-unused-vars: "off" */
import * as ko from 'knockout';
import flatpickr from 'flatpickr';
import { debounce } from 'underscore';
import contactAppointmentMehtods from '../modules/contact-appointment-methods';

const multistepInitMethods = {
  initDatepicker() {
    flatpickr('#calendar', {
      dateFormat: 'F d, Y',
      minDate: new Date(),
      disable: [
        // function(date) {
        //   return date.getDay() == 1;
        // }
      ],
      onChange: function(selectedDates, dateStr, instance) {
        let day = instance.parseDate(dateStr).getUTCDay();
        const mondayTimes = [
          '',
          '11AM',
          '12PM',
          '1PM',
          '2PM',
          '3PM',
          '4PM',
          '5PM',
          '6PM'
        ];
        const sundayTimes = ['', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM'];
        const tuesdayTimes = [
          '',
          '11AM',
          '12PM',
          '1PM',
          '2PM',
          '3PM',
          '4PM',
          '5PM',
          '6PM',
          '7PM'
        ];
        const saturdayTimes = [
          '',
          '10AM',
          '11AM',
          '12PM',
          '1PM',
          '2PM',
          '3PM',
          '4PM',
          '5PM',
          '6PM',
          '7PM'
        ];
        const defaultTimes = [
          '',
          '11AM',
          '12PM',
          '1PM',
          '2PM',
          '3PM',
          '4PM',
          '5PM',
          '6PM'
        ];
        let timeSelect = document.querySelector(
          'select[name="appointment_time"]'
        );
        // monday starts on 0
        if (day == 0 || day == 6 || day == 1 || day == 5) {
          // clean all the options
          while (timeSelect.firstChild) {
            timeSelect.removeChild(timeSelect.firstChild);
          }
          switch (day) {
            case 0: {
              mondayTimes.forEach(el => {
                let option = document.createElement('option');
                option.setAttribute('value', el);
                option.textContent = el;
                timeSelect.appendChild(option);
              });

              break;
            }
            case 6: {
              sundayTimes.forEach(el => {
                let option = document.createElement('option');
                option.setAttribute('value', el);
                option.textContent = el;
                timeSelect.appendChild(option);
              });
              break;
            }
            case 1: {
              tuesdayTimes.forEach(el => {
                let option = document.createElement('option');
                option.setAttribute('value', el);
                option.textContent = el;
                timeSelect.appendChild(option);
              });
              break;
            }
            case 5: {
              saturdayTimes.forEach(el => {
                let option = document.createElement('option');
                option.setAttribute('value', el);
                option.textContent = el;
                timeSelect.appendChild(option);
              });
              break;
            }
          }
        } else {
          // clean all the options
          while (timeSelect.firstChild) {
            timeSelect.removeChild(timeSelect.firstChild);
          }
          defaultTimes.forEach(el => {
            let option = document.createElement('option');
            option.setAttribute('value', el);
            option.textContent = el;
            timeSelect.appendChild(option);
          });
        }
      }
    });
  },
  initSteps() {
    let steps = document.querySelectorAll(
      '#multistep_appointment_form fieldset'
    );
    let stepsTitles = document.querySelectorAll('.steps-titles li');
    Array.prototype.forEach.call(steps, function(step, i) {
      if (i > 0) {
        step.classList.add('hide');
      }
    });
  }
};

export default {
  init() {
    multistepInitMethods.initSteps();
    ko.bindingHandlers.captureEvent = {
      init: (element, valueAccesor) => {
        let arg = valueAccesor();
        for (let eventName in arg) {
          element.addEventListener(eventName, arg[eventName], true);
        }
      }
    };
    const viewModel = new AppointmentViewModel();
    const domNode = document.querySelector('#multistep_appointment_form');
    console.log({ viewModel, domNode });
    ko.applyBindings(viewModel, domNode);
    // flatpickr(document.querySelector('#datepicker'), {});
    multistepInitMethods.initDatepicker();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};

function AppointmentViewModel() {
  this.personalData = {
    firstName: ko.observable(''),
    lastName: ko.observable(''),
    fullName: ko.pureComputed(
      () => this.personalData.firstName() + ' ' + this.personalData.lastName()
    ),
    phoneNumber: ko.observable(''),
    email: ko.observable('')
  };
  this.appointmentData = {
    appointmentLength: ko.observable(''),
    appointmentDate: ko.observable(''),
    appointmentTime: ko.observable(''),
    appointmentLocation: ko.observable(''),
    consultationInfo: ko.pureComputed(() => {
      return this.appointmentData.appointmentLength() !== '' &&
        this.appointmentData.appointmentDate() !== ''
        ? this.appointmentData.appointmentLength() +
            ', ' +
            this.appointmentLocation +
            ', ' +
            this.appointmentData.appointmentDate()
        : '';
    }),
    appointmentPurpose: ko.observable(''),
    customAppointmentPurpose: ko.observable('')
  };

  // checking if other is selected in Appointment Purpose
  // bind the value the display property of the custom purpose input field to a function that compares the value of appointmentPurpose and if its == to 'other' and returns true, if not, returns false and the input field is not shown

  // // step manager code
  this.currentStep = ko.observable(0);
  this.stepsTitles = ['Choose Date', 'Your Information', 'Confirmation'];
  this.disableBackButton = ko.observable(true);
  this.disableNextButton = ko.observable(false);
  this.nextStep = () => {
    // If its the last step simple do nothing
    if (this.currentStep() >= 2) {
      return;
    } else {
      let fieldsets = document.querySelectorAll('fieldset');
      let inputs = fieldsets[this.currentStep()].querySelectorAll(
        'input, select'
      );
      let valid = {
        areTheyValid: false,
        invalidInputs: []
      };
      valid.areTheyValid = Array.prototype.every.call(inputs, function(
        element
      ) {
        let state = element.checkValidity();
        if (!state) {
          valid.invalidInputs.push(element);
        }
        return state;
      });
      if (valid.areTheyValid) {
        this.currentStep(this.currentStep() + 1);
        this.updateUI();
      } else if (valid.invalidInputs.length > 0) {
        valid.invalidInputs[0].reportValidity();
      }
    }
  };
  this.previousStep = () => {
    if (this.currentStep() <= 0) {
      this.disableBackButton(true);
      return;
    } else {
      this.currentStep(this.currentStep() - 1);
      this.updateUI();
    }
  };
  this.updateMethods = {
    updateContent: () => {
      let steps = document.querySelectorAll(
        '#multistep_appointment_form fieldset'
      );
      for (let i = 0; i < steps.length; i++) {
        if (i == this.currentStep()) {
          steps[i].classList.remove('hide', 'animated', 'fadeOut');
          steps[i].classList.add('animated', 'fadeIn');
        } else {
          steps[i].classList.add('hide');
          steps[i].classList.add('animated', 'fadeOut');
        }
      }
    },
    checkButtons: () => {
      if (this.currentStep() <= 0) {
        this.disableBackButton(true);
        this.disableNextButton(false);
      } else if (this.currentStep() >= 2) {
        this.disableNextButton(true);
        this.disableBackButton(false);
      } else {
        this.disableBackButton(false);
        this.disableNextButton(false);
      }
    },
    updateActiveStepTitle: () => {
      let stepTitles = document.querySelectorAll('.steps-titles li');
      Array.prototype.forEach.call(
        stepTitles,
        function(step, i) {
          if (i === this.currentStep()) {
            step.classList.add('active');
          } else {
            step.classList.remove('active');
          }
        },
        this
      );
    }
  };
  this.updateUI = () => {
    this.updateMethods.updateContent();
    this.updateMethods.updateActiveStepTitle();
    this.updateMethods.checkButtons();
  };
  this.reschedule = () => {
    this.goToStep(0);
  };
  this.updatePersonalInfo = () => {
    this.goToStep(1);
  };
  this.goToStep = stepNumber => {
    this.currentStep(stepNumber);
    this.updateUI();
  };
  // this is a special version of the goToStep method specially suited to be called by the step title on the click binding.
  // is needed because there's no straightfoward way to pass the $index to a click handler inside a foreach binding
  this.koClickGoToStep = (index, data, event) => {
    this.currentStep(index);
    this.updateUI();
  };
  this.clearFields = () => {
    [this.personalData, this.appointmentData].forEach(function(dataSet) {
      for (let field in dataSet) {
        if (!ko.isComputed(dataSet[field]) && ko.isObservable(dataSet[field])) {
          dataSet[field]('');
        }
      }
    });
  };
  this.restartForm = () => {
    this.clearFields();
    this.goToStep(0);
  };
  this.insertLoadingIcon = selector => {
    // Removing the make appointment button with animate.css event and then setting display: none
    const elementToReplace = document.querySelector(selector);
    elementToReplace.addEventListener('animationend', e =>
      e.target.classList.add('hide')
    );
    elementToReplace.classList.add('animated', 'faster', 'fadeOut');

    // Adding the loader svg. The paths.dist is a global variable provided by a localized script in setup.php
    let loader = document.createElement('img');
    // eslint-disable-next-line no-undef
    loader.src =
      'https://glaudicollection.com/wp-content/themes/sage-woo/resources/assets/images/icons/loader.svg';
    loader.classList.add('loader', 'animated', 'fadeIn');
    loader.style.cssText += ';' + 'width:60px;height:60px;';
    elementToReplace.parentNode.appendChild(loader);
  };
  this.insertFetchResponse = (selector, message) => {
    let element = document.querySelector(selector);
    element.classList.add('hide');
    let result = document.createElement('p');
    result.classList.add('text-serif', 'text-md');
    result.innerText = message;
    element.parentNode.appendChild(result);
  };
  this.inputValidation = debounce(event => {
    const element = event.target;
    const isValid = element.checkValidity();
    if (isValid) {
      element.classList.add('valid');
      element.classList.remove('invalid');
    } else {
      element.classList.remove('valid');
      element.classList.add('invalid');
      element.reportValidity();
    }
  }, 500);
  this.formValidation = debounce(event => {
    const element = event.target;
    const parentFieldset = element.closest('fieldset');
    const fieldsets = document.querySelectorAll('fieldset');
    let errorStep = Array.prototype.indexOf.call(fieldsets, parentFieldset);
    this.goToStep(errorStep);
  });

  // Create Appointment sends a POST request to create the appointment which is handled by a custom AJAX endpooint
  this.createAppointment = formElement => {
    this.insertLoadingIcon('.action-buttons .submit');
    let form = new FormData(formElement);
    console.log({ form });
    form.append('action', 'create_appointment');
    // eslint-disable-next-line no-undef
    if (ajaxSettings) {
      // eslint-disable-next-line no-undef
      fetch(ajaxSettings.ajaxurl, {
        method: 'POST',
        headers: {
          'Cache-Control': 'no-cache'
        },
        body: form
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.statusText);
          }
          return response.text();
        })
        .then(
          data => {
            this.insertFetchResponse('.action-buttons .loader', data);
          },
          err => {
            this.insertFetchResponse(
              '.action-buttons .loader',
              'Sorry! Apparently there was a problem when creating the appointment. Send us an email or gives us a call to set up the appoinment!'
            );
          }
        );
    }
  };
  this.generateGCalendarLink = () => {
    return 'http://www.google.com/calendar/event?action=TEMPLATE&dates=20180802T160000Z%2F20180802T170000Z&text=Appointment%20At%20Glaudi%20Collection&location=1776%20N%20Sycamore%20Ave%2C%20Los%20Angeles%2C%20CA&details= ';
  };

  // code related to the appoinment purpose update
  this.appointmentMethods = contactAppointmentMehtods;
}



// WEBPACK FOOTER //
// ./scripts/routes/contact.js